// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__32r7F","title":"styles_title__3GUzJ","subtitle":"styles_subtitle__1kyCq"};